import React, { useState, useEffect, useCallback, useContext } from "react";
import ReactDOM from "react-dom";
import Modal from "../../../atoms/Modal/Modal";
import NewUIDropDown, {
    TYPES,
} from "../../../molecules/NewUIDropdown/NewUIDropDown";
import EditorContext from "../../TextEditor/EditorContext";
import TextHighlighter from "../../TextEditor/TextHighlighter";

import styles from "./KeyTerms.module.css";
import KeyTermsRow from "./KeyTermsRow";
import pluralize from "pluralize";
import RatingHook from "../../../molecules/Creator/Overview/RatingHook";

const options = [
    { title: "Importance", value: "Importance" },
    { title: "Unused", value: "Unused" },
    { title: "Heading Presence", value: "Heading Presence" },
];

const orderOptions = {
    asc: 1,
    desc: 2,
};

export default function KeyTerms({
    list = [],
    editorText,
    toggleModal,
    setKeyWord,
    reportInfo,
    keyWord,
    writingState,
    setWritingState,
    aiWordLimitSetting,
    setAiWordLimitSetting,
    writeWithAnimation,
    selection,
}) {
    const [order, setOrder] = useState(orderOptions.desc);
    const [sortBy, setSortBy] = useState(options[0]);
    const [highlight, setHighlight] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const [_list, setLIst] = useState(list);
    const { saving, versionData } = useContext(EditorContext);

    useEffect(() => {
        setHighlight(false);
    }, [versionData]);

    // useEffect(() => {
    //     console.log(sortBy, order);
    //     const arr = list?.sort(sortingFunction);
    //     setLIst(list?.sort(sortingFunction));
    // }, [list]);

    const _setUsed = (bool, index) => {
        // _list[index].used = bool;
        // setLIst(_list);
        setLIst((prev) => {
            prev[index].used = bool;
            return prev;
        });
    };

    useEffect(() => {
        setHighlight(false);
    }, [versionData]);

    useEffect(() => {
        (async () => {
            const rating = await RatingHook(
                document.quill?.editor?.getText(),
                list.map((item) => ({
                    ...item,
                    singular: pluralize.singular(item?.keyword),
                    plural: pluralize.plural(item?.keyword),
                })),
                "keyTerms",
            );

            setLIst(rating.keyTermslist);
        })();
    }, [saving, list]);
    const sortingFunction = (item1, item2) => {
        if (order == orderOptions.asc) {
            const temp = item2;
            item2 = item1;
            item1 = temp;
        }
        if (sortBy.value == "Importance") {
            return item2.importance - item1.importance;
        } else if (sortBy.value == "Unused") {
            return item1.used - item2.used;
        } else {
            return item2.heading_presence - item1.heading_presence;
        }
    };

    return (
        <div className={styles.tableContainer}>
            {/* <ImSortAmountDesc
        onClick={() => setSortingMenu(!sortingMenu)}
        className={styles.sortIcon}
        color="#29394a"
      /> */}

            {highlight && (
                <TextHighlighter keyTerms={_list.filter((ele) => ele.status)} />
            )}

            <div className={styles.sortOptionsButton}>
                <div
                    onClick={() => setHighlight((ps) => !ps)}
                    className={styles.highlight}
                >
                    <input checked={highlight} type="checkbox" />
                    <span>Highlight Usage</span>
                </div>
                <NewUIDropDown
                    setOrder={setOrder}
                    order={order}
                    options={options}
                    type={TYPES.SORT}
                    handler={setSortBy}
                    selectedOption={sortBy}
                    style={{
                        borderRadius: 3,
                        border: "1px solid #D9D9D9",
                        borderColor: "#D9D9D9",
                        color: "#6b6b6b",
                    }}
                />
            </div>

            {/* <table className={styles.table} id="key-terms"> */}

            <div className={`${styles.containerDiv} ${styles.keyTermsHeader}`}>
                <span style={{ position: "absolute", top: -65 }}></span>
                <div className={`${styles.mainDiv} ${styles.headerMainDiv}`}>
                    <div
                        style={{ width: "30px" }}
                        className={`${styles.leftContainer} ${styles.keytermHeading}`}
                    ></div>
                    <div
                        className={`${styles.leftContainer} ${styles.keytermHeading}`}
                    >
                        Usage
                    </div>
                    <div
                        className={`${styles.leftInfoContainer} ${styles.keytermHeading}`}
                    >
                        Keyterm
                    </div>
                    <div
                        className={`${styles.leftCommonInfo} ${styles.keytermHeading}`}
                    >
                        Importance
                    </div>

                    <div className={styles.rightContainer}></div>
                </div>
            </div>
            {_list.sort(sortingFunction).map((item, i) => {
                return (
                    <KeyTermsRow
                        index={i}
                        list={_list}
                        _setUsed={_setUsed}
                        item={item}
                        editorText={editorText}
                        toggleModal={toggleModal}
                        setKeyWord={setKeyWord}
                        reportInfo={reportInfo}
                        keyWord={keyWord}
                        writingState={writingState}
                        setWritingState={setWritingState}
                        key={item.id}
                        isDeleting={isDeleting}
                        setIsDeleting={setIsDeleting}
                        writeWithAnimation={writeWithAnimation}
                    />
                );
            })}
            {/* </table> */}
        </div>
    );
}
